<template>
  <v-form ref="formDadosBancarios" lazy-validation>
    <v-layout row wrap class="contact-row">
      <v-flex xs12 v-if="showCpom && !readonly">
        <v-alert v-model="alert" dismissible outlined type="warning"
          >Evite a retenção do ISS! Informe os dados do Responsável para
          efetuarmos seu cadastro no CPOM Curitiba.</v-alert
        >
      </v-flex>

      <v-flex md4 sm12 v-if="showCpom">
        <v-text-field
          class="form-input-box"
          label="CPF do Diretor Resposável"
          v-model="dados_bancarios.cpf_responsavel"
          :rules="[rules.obrigatorio, rules.cpfInvalido]"
          :readonly="readonly"
          v-mask="'###.###.###-##'"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex md8 sm12 v-if="showCpom">
        <v-text-field
          class="form-input-box"
          label="Nome do Diretor Resposável"
          v-model="dados_bancarios.nome_responsavel"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex md4 sm12>
        <v-autocomplete
          v-model="dados_bancarios.banco"
          :items="bancos"
          :no-data-text="'Nenhum resultado encontrado.'"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          item-text="nome"
          item-value="id"
          class="form-select-box"
          label="Banco"
          placeholder="Selecionar"
        ></v-autocomplete>
      </v-flex>

      <v-flex md4 sm12>
        <v-text-field
          class="form-input-box"
          label="Agência"
          v-model="dados_bancarios.agencia"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          v-mask="'######'"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex md4 sm12>
        <v-text-field
          class="form-input-box"
          label="Conta"
          v-model="dados_bancarios.conta"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          v-mask="'##################'"
          placeholder=" "
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script lang="js">
import { isValidCpf } from "@/libs/utils";

export default {
  name: "DadosBancariosComponent",
  data() {
    return {
      alert: true,
      rules: {
        obrigatorio: (v) => !!v || "Campo obrigatório",
        cpfInvalido: (v) =>
          (!!v && isValidCpf(v)) || "CPF inválido",
      },
    };
  },
  props: ["bancos", "dados_bancarios", "showCpom", "readonly"],
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/DadosBancariosComponent.vue